import {
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
  Input,
  ViewChildren,
  QueryList,
  Output,
  ChangeDetectorRef,
  HostListener
} from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { DocumentsType } from '../../../models/_enum-collections';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { EngagementPreviewInput } from '../../../models/engagement-preview-input.model';
import { EngagementSearchAndFilterInput } from '../../../models/engagement-search-and-filter-input.model';
import { L1InternalStatus } from '../../../models/l1-internal-status.model';
import { L2InternalStatus } from '../../../models/l2-internal-status.model';
import { PartnerInput } from '../../../models/partner-input.model';
import { TaskOwner } from '../../../models/task-owner.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { AppConstants } from '../../common/app-constants';
import { EditComponent } from '../../home/edit/edit.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';
import { EngagementPreviewComponent } from '../../preview/engagement-preview/engagement-preview.component';

@Component({
  selector: 'app-special-investment-table',
  templateUrl: './special-investment-table.component.html',
  styleUrls: ['./special-investment-table.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EditComponent, EngagementPreviewComponent]
})
export class SpecialInvestmentTableComponent implements OnInit {
  scrollableCols = new Array<any>();
  globalFilterCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  pageLinksPerPage!: number;
  dataViewRecsPerPage!: number;
  tblPageNumber!: number;
  totalRecords!: number;
  display!: boolean;
  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  engagementEditInput!: EngagementEditInput;
  showFullscreen = false;
  canShowPreviewModel!: boolean;
  excelLoading = false;
  taskOwnerDrpdwn!: TaskOwner[];
  ftaskOwnerDrpdwn: SelectItem[] = [];

  @ViewChild('dt', { static: false }) dt!: Table;
  @Input() engagementList!: PartnerInput[];
  @Input() isPoeDoc!: boolean;
  @Input() isPoeInvoice!: boolean;
  @Input() loading!: boolean;
  @Input() prevDocumentType!: string;
  @Input() isRFPAwardLetter!: boolean;
  @Input() isRFPDescription!: boolean;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;

  engagementPreviewInput!: EngagementPreviewInput;
  @Output() refreshList = new EventEmitter<any>();
  sortableColumnForUploadedDate!: string;

  @Input() totalCount;
  @Input() currentTabname;
  l1InternalStatus1!: L1InternalStatus[];
  fl1InternalStatusDrpdwn: SelectItem[] = [];
  l2InternalStatus1!: L2InternalStatus[];
  l2InternalStatus1Drpdwn: SelectItem[] = [];
  poeStatusDrpdwn: SelectItem[] = [];
  currentPage!: string;

  searchAndFilterInput!: EngagementSearchAndFilterInput;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;
  currentSearchSubscription!: Subscription;
  pmos!: PartnerInput[];

  constructor(
    public localStorage: LocalStorageService,
    private osmEdit: OsmosisEditService,
    private osm: OsmosisService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {}

  @HostListener('window:resize') onresize(): void {
    requestAnimationFrame(() => {
      if (document && document.querySelector('#engagementEdit')) {
        const editEngagement = document
          .querySelector('#engagementEdit')
          ?.querySelector<HTMLElement>('[role="dialog"]');

        if (editEngagement) {
          editEngagement.style.width = '90%';
          editEngagement.style.height = '85%';
        }
      }
    });
  }

  ngOnInit() {
    this.loadEngagementDetails();
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.display = false;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();
    this.engagementEditInput = {
      showFullScreen: this.showFullscreen
    } as any;
    if (
      this.prevDocumentType === PreviewDocumentTypes.customerAcknowledgement
    ) {
      this.sortableColumnForUploadedDate = 'acknowledgementDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.poeinvoice) {
      this.sortableColumnForUploadedDate = 'invoiceUploadedDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.poedocument) {
      this.sortableColumnForUploadedDate = 'poeUploadedDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.customerSurvey) {
      this.sortableColumnForUploadedDate = 'customerSurveyDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.rfpAward) {
      this.sortableColumnForUploadedDate = 'rfpAwardLetterUploadDate';
    } else if (this.prevDocumentType === PreviewDocumentTypes.rfpDescription) {
      this.sortableColumnForUploadedDate = 'rfpDescriptionUploadDate';
    }
    this.scrollableCols = [
      { field: 'engagementKey', header: 'Engagement Key' },
      { field: 'taskOwner', header: 'Task Owner' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'engagementSubType', header: 'Engagement Sub Type' },
      { field: 'partnerInputCustomerCountry', header: 'Customer Country' },
      { field: 'partnerInputParnterName', header: 'Partner Org' },
      { field: 'partnerInputCustomerName', header: 'Customer Org' },
      { field: 'l1InternalStatus', header: 'L1Internal status' },
      { field: 'status', header: 'L2Internal status' }
    ];

    this.globalFilterCols = [
      'engagementKey',
      'taskOwner',
      'pmoNextSteps',
      'l1InternalStatus',
      'poeStatus',
      'opsStatus',
      'requestID',
      'requestDate',
      'engagementType',
      'engagementSubType',
      'partnerInputPartnerName',
      'partnerInputMPNId',
      'partnerInputSupplierId',
      'requestorFullName',
      'requestorEmail',
      'partnerInputCustomerName',
      'partnerInputCustomerCountry',
      'partnerInputCustomerTPId',
      'partnerInputCustomerTenantId',
      'partnerInputCustomerDomainName',
      'partnerInputComments'
    ];
    this.scrollableCols.push({
      field: this.sortableColumnForUploadedDate,
      header: 'Uploaded Date'
    });
    this.globalFilterCols.push(this.sortableColumnForUploadedDate);
    this.getTaskOwnerList();
    this.getL1InternalStatusList();
    this.getL2InternalStatusList();
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  get currentPageInfo(): string {
    if (this.engagementList != null) {
      this.totalRecords = this.engagementList.length;
    }
    if (this.totalRecords === 0) {
      return 'No Record Found';
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage >
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.tblPageNumber + this.dataViewRecsPerPage <=
      this.totalRecords
    ) {
      return (
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords > this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    } else if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      return (
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records'
      );
    }
    return '';
  }
  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.pageChange({ first: 0 });
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'taskOwner', 'in');
      this.dt.filter('', 'l1InternalStatus', 'in');
      this.dt.filter('', 'engagementType', 'in');
      this.dt.reset();
    }

    this.display = false;
    this.refreshList.emit(true);
    this.loadEngagementDetails();
  }

  editRequestDetails(id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.requestDetailId = id;
    this.engagementIdPassToChild = id;
    this.engagementEditInput = {
      engagementId: this.engagementIdPassToChild
    } as any;

    if (this.editNavChild) {
      this.editNavChild.fillEditValues(id);
    }
  }

  getUploadedDate(rawData): Date {
    switch (this.prevDocumentType) {
      case PreviewDocumentTypes.customerAcknowledgement: {
        return rawData.acknowledgementDate;
      }
      case PreviewDocumentTypes.poedocument: {
        return rawData.poeUploadedDate;
      }
      case PreviewDocumentTypes.poeinvoice: {
        return rawData.invoiceUploadedDate;
      }
      case PreviewDocumentTypes.customerSurvey: {
        return rawData.customerSurveyDate;
      }
      case PreviewDocumentTypes.rfpAward: {
        return rawData.rfpAwardLetterUploadDate;
      }
      case PreviewDocumentTypes.rfpDescription: {
        return rawData.rfpDescriptionUploadDate;
      }
      default: {
        return new Date();
      }
    }
  }
  clearSearchText() {
    this.searchAndFilterInput.searchString = '';
    this.searchOrFilterEngagements();
  }

  searchOrFilterEngagements() {
    this.searchAndFilterInput.page = 1;
    if (this.dt) {
      this.dt.first = this.searchAndFilterInput.page;
    }
    this.delayedLoadSearchContent();
  }
  computeResultsCountText() {
    if (this.totalRecords === 0) {
      this.currentPage = 'No Record Found';
    } else {
      const currentStartCount =
        (this.searchAndFilterInput.page - 1) * this.dataViewRecsPerPage;
      const currentEndCount = currentStartCount + this.dataViewRecsPerPage;
      this.currentPage =
        'Showing ' +
        (currentStartCount + 1) +
        ' - ' +
        (currentEndCount > this.totalRecords
          ? this.totalRecords
          : currentEndCount) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }
  getTaskOwnerList() {
    this.osmEdit.getTaskOwnerDropDown().subscribe(PTList => {
      this.taskOwnerDrpdwn = PTList;
      for (const item of this.taskOwnerDrpdwn) {
        const ftaskOwnerDrpdwn: SelectItem = {
          label: item.taskOwner,
          value: item.taskOwner
        };
        this.ftaskOwnerDrpdwn.push(ftaskOwnerDrpdwn);
      }
    });
  }

  getL1InternalStatusList() {
    this.osmEdit.getL1InternalStatusForSiDropDown().subscribe(PTList => {
      this.l1InternalStatus1 = PTList;
      for (const item of this.l1InternalStatus1) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l1internalStatus,
          value: item.l1internalStatus
        };
        this.fl1InternalStatusDrpdwn.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  getL2InternalStatusList() {
    this.osmEdit.getL2InternalStatusForSiDropDown().subscribe(PTList => {
      this.l2InternalStatus1 = PTList;
      for (const item of this.l2InternalStatus1) {
        const l2InternalStatus1Drpdwn: SelectItem = {
          label: item.l2internalStatus,
          value: item.l2internalStatus
        };
        this.l2InternalStatus1Drpdwn.push(l2InternalStatus1Drpdwn);
      }
    });
  }

  refresh() {
    this.refreshList.emit(true);
    this.loadEngagementDetails();
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
    this.refreshList.emit(true);
    this.loadEngagementDetails();
  }

  redirectToPartner(partnerMpnId: string) {
    this.router.navigate(['/partner-dashboard'], {
      queryParams: { mpnId: partnerMpnId }
    });
  }

  export() {
    this.router.navigate(['/download-csv']);
  }

  loadEngagementDetails() {
    this.loading = true;
    this.osm
      .getEngagementsForSpecialInvestments(this.currentTabname)
      .subscribe(serviceOutput => {
        this.engagementList = serviceOutput;
        this.loading = false;
      });
  }

  previewFile(engementId) {
    this.engagementPreviewInput = {
      engagementId: engementId,
      previewFileIndex: 0,
      isCustomerAckApproval: false,
      documentType:
        this.prevDocumentType === PreviewDocumentTypes.poedocument
          ? PreviewDocumentTypes.poedocument
          : this.prevDocumentType,
      engagementIdList: this.engagementList
        .filter(engagement => engagement.engagementKey !== undefined)
        .map(engagement => engagement.engagementKey as number),
      isPoePreview: true,
      documentTypeId: -1,
      isHistoryDocument: false,
      customerSurveyResponse: []
    };

    if (
      this.prevDocumentType === PreviewDocumentTypes.customerAcknowledgement
    ) {
      this.engagementPreviewInput.isCustomerAckApproval = true;
    }

    if (this.prevDocumentType === PreviewDocumentTypes.poeinvoice) {
      this.engagementPreviewInput.documentTypeId = DocumentsType.POEInvoice;
    } else if (this.prevDocumentType === PreviewDocumentTypes.poedocument) {
      this.engagementPreviewInput.documentTypeId = DocumentsType.POEDocument;
    } else if (this.prevDocumentType === PreviewDocumentTypes.rfpAward) {
      this.engagementPreviewInput.documentTypeId =
        DocumentsType.RequestForProposalAwardLetter;
    } else if (this.prevDocumentType === PreviewDocumentTypes.rfpDescription) {
      this.engagementPreviewInput.documentTypeId =
        DocumentsType.RequestForProposalDescription;
    }

    this.canShowPreviewModel = true;
  }

  closePreview() {
    this.canShowPreviewModel = false;
    this.engagementPreviewInput = {} as EngagementPreviewInput;
  }

  get showPreviewButton() {
    return this.prevDocumentType === PreviewDocumentTypes.rfpDescription ||
      this.prevDocumentType === PreviewDocumentTypes.rfpAward
      ? false
      : true;
  }
}
